(function() {
    'use strict';

    angular
        .module('szallodak-test', ['dropzone'])
        .config(config);

        function config() {

        }
})();
